__turbopack_context__.v({
  "description": "syntax-guide-module-scss-module__5HUdGa__description",
  "searchGuide": "syntax-guide-module-scss-module__5HUdGa__searchGuide",
  "searchGuideContainer": "syntax-guide-module-scss-module__5HUdGa__searchGuideContainer",
  "searchSnippets": "syntax-guide-module-scss-module__5HUdGa__searchSnippets",
  "syntaxGuideContainer": "syntax-guide-module-scss-module__5HUdGa__syntaxGuideContainer",
});
